export interface QueuePeriodicAnnouncementItemView {
   queuePeriodicAnnouncementId: number;
   prompt: PromptViewModel;
   sortOrder: number;
   isDeleted: boolean;
}

export interface PromptViewModel {
   promptId: number;
   name: string;
   file: PromptFileViewModel;
}

export interface PromptFileViewModel {
   fileToken: string;
}

export const queuePeriodicAnnouncementFields: string[] = [
   'queuePeriodicAnnouncementId',
   'extensionQueueId',
   'promptId',
   'sortOrder',
];
